import {
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { addressSelectionUI } from 'platform/shared/health-apps';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['secondary-two-address--selection-title'];
const INPUT_LABELS = {
  selection: content['secondary-two-address--selection-label'],
  sameAs: content['secondary-two-address--same-as-label'],
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    'view:secondaryTwoSharedAddress': addressSelectionUI({
      title: INPUT_LABELS.selection,
      destinationKey: 'secondaryTwoAddress',
      sourceKeys: ['veteranAddress', 'primaryAddress', 'secondaryOneAddress'],
    }),
    'view:secondaryTwoHomeSameAsMailingAddress': yesNoUI(INPUT_LABELS.sameAs),
  },
  schema: {
    type: 'object',
    required: [
      'view:secondaryTwoSharedAddress',
      'view:secondaryTwoHomeSameAsMailingAddress',
    ],
    properties: {
      'view:secondaryTwoSharedAddress': { type: 'string' },
      'view:secondaryTwoHomeSameAsMailingAddress': yesNoSchema,
    },
  },
};
